<template>
  <div class="xl:ml-3 relative">
    <jet-dropdown align="right" width="48" v-if="$page.props.user">
      <template #trigger>
        <menu-account-trigger class="hidden xl:block"/>
      </template>

      <template #content>
        <!-- Account Management -->
        <menu-account-content/>
      </template>
    </jet-dropdown>
    <inertia-link :href="route('login')"
                  class="flex items-center text-dark-blue xl:text-white my-3 xl:my-0"
                  v-else>
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <span class="ml-2">{{ $trans('app.menu.my-account') }}</span>
    </inertia-link>
    <div class="xl:hidden" v-if="$page.props.user">
      <hr class="mt-4">
      <menu-account-content class="xl:hidden"/>
    </div>
  </div>
</template>
<script>
import JetDropdown from '@/Jetstream/Dropdown'
import MenuAccountContent from "@/Components/MenuAccountContent";
import MenuAccountTrigger from "./MenuAccountTrigger";

export default {
  name: 'menu-account',
  components: {MenuAccountTrigger, MenuAccountContent, JetDropdown},
  props: {
    //
  },
}
</script>
